/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { authenticate } from '../fn/auth-n-and-auth-z/authenticate';
import { Authenticate$Params } from '../fn/auth-n-and-auth-z/authenticate';
import { LoginResponse } from '../models/login-response';


/**
 * Endpoints for machine-to-machine authentication via AWS Cognito. The POST /auth/login endpoint itself requires a valid Bearer JWT with the OAuth2 scope 'mkp/auth.login'. Obtain this token from the Cognito user pool using the client credentials or password flow before calling this endpoint.
 */
@Injectable({ providedIn: 'root' })
export class AuthNAndAuthZService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authenticate()` */
  static readonly AuthenticatePath = '/auth/login';

  /**
   * Authenticates a user (M2M).
   *
   * Authenticates a Cognito user with username/password and returns Cognito tokens (idToken, accessToken, refreshToken). This endpoint is intended for machine-to-machine flows where a service needs to obtain user-scoped tokens on behalf of a user. The caller must already hold a valid Bearer JWT with the OAuth2 scope 'mkp/auth.login'. Returns 403 if credentials are invalid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticate$Response(params: Authenticate$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginResponse>> {
    const obs = authenticate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Authenticates a user (M2M).
   *
   * Authenticates a Cognito user with username/password and returns Cognito tokens (idToken, accessToken, refreshToken). This endpoint is intended for machine-to-machine flows where a service needs to obtain user-scoped tokens on behalf of a user. The caller must already hold a valid Bearer JWT with the OAuth2 scope 'mkp/auth.login'. Returns 403 if credentials are invalid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticate(params: Authenticate$Params, context?: HttpContext): Observable<LoginResponse> {
    const resp = this.authenticate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LoginResponse>): LoginResponse => r.body)
    );
  }

}
